export enum TextEditor {

    SAVE_TEXT_DATA = "SAVE_TEXT_DATA",
    SAVE_TEXT_DATA_SUCCESS = "SAVE_TEXT_DATA_SUCCESS",
    SAVE_TEXT_DATA_FAIL = "SAVE_TEXT_DATA_FAIL",

    SET_DRAWER_PROPERTIES = "SET_DRAWER_PROPERTIES",
    SET_DRAWER_PROPERTIES_SUCCESS = "SET_DRAWER_PROPERTIES_SUCCESS",
    SET_DRAWER_PROPERTIES_FAIL = "SET_DRAWER_PROPERTIES_FAIL",

    GET_STANDARD_ADAPTERS = "GET_STANDARD_ADAPTERS",
    GET_STANDARD_ADAPTERS_SUCCESS = "GET_STANDARD_ADAPTERS_SUCCESS",
    GET_STANDARD_ADAPTERS_FAIL = "GET_STANDARD_ADAPTERS_FAIL",

    DELETE_TEXT_DATA = "DELETE_TEXT_DATA",
    DELETE_TEXT_DATA_SUCCESS = "DELETE_TEXT_DATA_SUCCESS",
    DELETE_TEXT_DATA_FAIL = "DELETE_TEXT_DATA_FAIL",
  
  }
  